export default __webpack_public_path__ + "static/media/LAS0880.34I-39651_-23569_0.8cc6824c.jpg";